import { FlexBox } from '@fable/components'
import { css } from '@fable/theme'
import { ReaderStatCard } from './ReaderStatCard'
import { useStatCards } from './useStatCards'
import { useReaderSummary } from '../../../lib/ctx/reader_summary'

export const ReaderStatCards = () => {
  const status = useReaderSummary((s) => s.status)
  const cards = useStatCards()

  return (
    <FlexBox
      className={css`
        width: 100%;
        gap: 8px;
        padding-top: ${status === 'hidden' ? 28 : 0}px;
      `}
    >
      {cards.map((stat, i) => (
        <ReaderStatCard key={i} {...stat} />
      ))}
    </FlexBox>
  )
}
